<style lang="scss">
@import "resources/sass/v1/abstracts/_variables";

.inline-dropdown {
    .main-link a {
        position: relative;
        color: #fff !important;

        &:after {
            content: "";
            width: 7px;
            height: 4px;
            background-image: url("/svg/chevron-up-white.svg");
            background-size: contain;
            background-repeat: no-repeat;
            position: absolute;
            left: calc(100% + 8px);
            top: 50%;
            transform: translateY(-3px) rotate(180deg) translateY(-50%);
            transform-origin: center center;
            transition: transform 0.3s;
        }
    }

    .dropdown {
        position: relative;
        width: 100%;
        overflow: hidden;
        max-height: 1px;
        transition: max-height 0.2s;

        a {
            display: inline-block;
            color: #ffffff;
            font-size: 20px;
            letter-spacing: 0.75px;
            line-height: 30px;
            width: 100%;
            font-weight: $font-weight-normal;
            transition: color 0.2s;

            &.active {
                color: $secondary !important;
                font-weight: $font-weight-bold;
            }
        }
    }

    &.active {
        .main-link a {
            &:after {
                transform: translateY(-50%);
            }
        }

        .dropdown {
            max-height: 200px;
        }
    }
}
</style>

<template>
    <div class="inline-dropdown" :class="{'active': dropdownActive}">
        <div class="main-link" @click.prevent="toggleDropdown()">
            <slot name="main-link"></slot>
        </div>

        <div class="dropdown">
            <div class="dropdown-inner mt-8">
                <slot name="dropdown-content"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dropdownIsOpen: false
        }
    },

    methods: {
        toggleDropdown() {
            this.dropdownIsOpen = !this.dropdownIsOpen;
        }
    },

    computed: {
        dropdownActive() {
            return this.dropdownIsOpen;
        }
    }
}
</script>